define('views/pages/dashboard/news',['require','views/base/view','views/base/collection','views/pages/dashboard/panel','text!templates/pages/dashboard/news.ejs','text!templates/pages/dashboard/news-item.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        DashboardPanel = require('views/pages/dashboard/panel'),
        template = require('text!templates/pages/dashboard/news.ejs'),
        templateItem = require('text!templates/pages/dashboard/news-item.ejs');

    var NewsItemView = View.extend({
        className: 'news',
        template: templateItem,
        render: function() {
            View.prototype.render.apply(this, arguments);
            if (!this.model.get('Readed')) {
                this.$el.addClass('news-new');
            }
        }
    });

    var NewsCollectionView = CollectionView.extend({
        autoRender: true,
        template: template,
        itemView: NewsItemView,
        className: 'news-list'
    });

    var NewsPanelView = DashboardPanel.extend({
        autoRender: true,
        listen: {
            'change:loading model': 'render'
        },
        render: function() {
            DashboardPanel.prototype.render.apply(this, arguments);
            this.subview('list', new NewsCollectionView({ collection: this.model.items, model: this.model, container: this.$('.panel-content') }));
        }
    });

    return NewsPanelView;
});

